<!--
  @Author: Yu XiuJie
  @Desc: 公众号进来的首页
  @Date: 2021-04-16 18时
-->
<template>
  <div class="page-main" id="officialAccount">
    <!-- 我们的服务行业 -->
    <div class="index_service">
      <div class="service_title">慧用工｜致力于助力每一个优秀的公司</div>
      <!-- 轮播图 -->
      <m-swipe></m-swipe>
    </div>

    <!--立即预约-->
    <div class="appointment">
      <div id="information">
        <mFromPage
          :source="paramQuery.source"
          ><span class="pop-box-title"
            >预约咨询</span
          ></mFromPage
        >
      </div>
    </div>
  </div>
</template>

<script>  
  import mSwipe from "../../components/mSwipe.vue";
  import mFromPage from "../../components/mFromPage";

  export default {
    name: 'mIndex-official-page',
    components: {
      mSwipe: mSwipe,
      mFromPage: mFromPage,
    },
    data(){
      return{      
        paramQuery: {
          name:'',
          phone:'',
          companyName:'',
          source:'',
          bdVid:'',
        },
      }
    },

    created(){
      // source标记来源于H5
      this.paramQuery.source = 'pageFrom=official_account'
    },

    methods: {

    }
  }
</script>


<style lang="scss" scoped>

.appointment{
  overflow: hidden;
  background-image: url(../../../static/mobile/index/img_bg.png);
  background-repeat:no-repeat;
  background-size: 100%;
  background-color: #F9FBFD;
  #information{
    margin: 90px auto;
    width: 690px;
    background: #FFFFFF;
    border-radius: 16px;
  }
}

.index_service {
  width: 100%;
  position: relative;
  overflow: hidden;
  .service_title {
    margin: 40px auto 31px;
    height: 56px;
    font-size: 35px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100f0f;
    line-height: 56px;
  }
  
}

</style>


// WEBPACK FOOTER //
// src/views/mobile/mIndexOfficialPage.vue